module.exports =
/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
/******/ 		}
/******/ 	};
/******/
/******/ 	// define __esModule on exports
/******/ 	__webpack_require__.r = function(exports) {
/******/ 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 		}
/******/ 		Object.defineProperty(exports, '__esModule', { value: true });
/******/ 	};
/******/
/******/ 	// create a fake namespace object
/******/ 	// mode & 1: value is a module id, require it
/******/ 	// mode & 2: merge all properties of value into the ns
/******/ 	// mode & 4: return value when already ns object
/******/ 	// mode & 8|1: behave like require
/******/ 	__webpack_require__.t = function(value, mode) {
/******/ 		if(mode & 1) value = __webpack_require__(value);
/******/ 		if(mode & 8) return value;
/******/ 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
/******/ 		var ns = Object.create(null);
/******/ 		__webpack_require__.r(ns);
/******/ 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
/******/ 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
/******/ 		return ns;
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = "./src/Input/index.ts");
/******/ })
/************************************************************************/
/******/ ({

/***/ "./src/Input/index.ts":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);

// EXTERNAL MODULE: external "react"
var external_react_ = __webpack_require__("react");
var external_react_default = /*#__PURE__*/__webpack_require__.n(external_react_);

// EXTERNAL MODULE: external "styled-components"
var external_styled_components_ = __webpack_require__("styled-components");
var external_styled_components_default = /*#__PURE__*/__webpack_require__.n(external_styled_components_);

// EXTERNAL MODULE: external "react-text-mask"
var external_react_text_mask_ = __webpack_require__("react-text-mask");
var external_react_text_mask_default = /*#__PURE__*/__webpack_require__.n(external_react_text_mask_);

// EXTERNAL MODULE: external "@carvana/theme"
var theme_ = __webpack_require__("@carvana/theme");

// EXTERNAL MODULE: external "@carvana/icons/AlertCircle"
var AlertCircle_ = __webpack_require__("@carvana/icons/AlertCircle");
var AlertCircle_default = /*#__PURE__*/__webpack_require__.n(AlertCircle_);

// EXTERNAL MODULE: external "@carvana/icons/CheckCircle"
var CheckCircle_ = __webpack_require__("@carvana/icons/CheckCircle");
var CheckCircle_default = /*#__PURE__*/__webpack_require__.n(CheckCircle_);

// CONCATENATED MODULE: ./src/Input/Input.styles.ts





var iconOffSet = '10px';
var CheckmarkIcon = external_styled_components_default()(CheckCircle_default.a).withConfig({
  displayName: "CheckmarkIcon",
  componentId: "oo6j68-0"
})(["color:", ";position:absolute;top:", ";right:", ";width:15px;height:15px;"], Object(theme_["cvGreen"])('primary'), iconOffSet, iconOffSet);
var PasswordToggler = external_styled_components_default.a.div.withConfig({
  displayName: "PasswordToggler",
  componentId: "oo6j68-1"
})(["display:none;cursor:pointer;position:absolute;font-weight:700;color:", ";font-size:12px;right:10px;bottom:10px;text-transform:uppercase;&:hover{display:block;}"], Object(theme_["cvBlue"])('primary'));
var ErrorIcon = external_styled_components_default()(AlertCircle_default.a).withConfig({
  displayName: "ErrorIcon",
  componentId: "oo6j68-2"
})(["color:", ";width:15px;height:15px;position:absolute;top:", ";right:", ";"], Object(theme_["cvRed"])('primary'), iconOffSet, iconOffSet);
var hideValdiationIconsWhenFocused = Object(external_styled_components_["css"])(["&:focus ~ ", "{display:none;}"], CheckmarkIcon);
var showPasswordToggleWhenFocused = Object(external_styled_components_["css"])(["&:focus ~ ", ",&:hover ~ ", "{display:block;}"], PasswordToggler, PasswordToggler);
var FormControl = external_styled_components_default.a.div.withConfig({
  displayName: "FormControl",
  componentId: "oo6j68-3"
})(["font-family:", ";position:relative;display:flex;flex-flow:column;width:100%;", " &.is-disabled{cursor:not-allowed;background-color:", ";label{color:", ";}}&.show-error-icon{input{border-color:", ";}label{color:", ";}}&.is-focused:not(.show-error-icon){label{color:", ";}}input::-webkit-credentials-auto-fill-button{display:none !important;}input::-ms-clear,input::-ms-reveal{display:none;}input:-internal-autofill-selected{-webkit-text-fill-color:", ";}&.is-populated,&.is-focused{label{transform:translate(17px,14px) scale(1);font-weight:700;font-size:10px;}}"], theme_["cvFontFamily"], function (props) {
  return props.multiline ? Object(external_styled_components_["css"])(["height:150px;"]) : Object(external_styled_components_["css"])(["height:60px;"]);
}, Object(theme_["cvGray"])('background'), Object(theme_["cvGray"])('light'), Object(theme_["cvRed"])('primary'), Object(theme_["cvRed"])('primary'), Object(theme_["cvBlue"])('primary'), Object(theme_["cvGray"])('dark'));
var inputCss = Object(external_styled_components_["css"])(["color:", ";background:", ";border:1px solid ", ";padding:1rem 1rem 0 1rem;flex:1;border-radius:3px;outline:none;font-size:14px;appearance:none;background-clip:padding-box;@keyframes onAutoFillStart{};@keyframes onAutoFillCancel{};&:-webkit-autofill{animation-name:onAutoFillStart;transition:background-color 50000s ease-in-out 0s;}&:not(:-webkit-autofill){animation-name:onAutoFillCancel;}&:disabled{cursor:not-allowed;background:", ";}&:focus{border:1px solid ", ";}", " ", ""], Object(theme_["cvGray"])('dark'), Object(theme_["cvWhite"])('primary'), Object(theme_["cvGray"])('light'), Object(theme_["cvGray"])('background'), Object(theme_["cvBlue"])('primary'), hideValdiationIconsWhenFocused, showPasswordToggleWhenFocused);
var TextMaskedInput = external_styled_components_default()(external_react_text_mask_default.a).withConfig({
  displayName: "TextMaskedInput",
  componentId: "oo6j68-4"
})(["", ""], inputCss);
var FormInput = external_styled_components_default.a.input.withConfig({
  displayName: "FormInput",
  componentId: "oo6j68-5"
})(["", ""], inputCss);
var TextArea = external_styled_components_default.a.textarea.withConfig({
  displayName: "TextArea",
  componentId: "oo6j68-6"
})(["", " padding-top:2rem;resize:none;"], inputCss);
var Label = external_styled_components_default.a.label.withConfig({
  displayName: "Label",
  componentId: "oo6j68-7"
})(["position:absolute;text-transform:uppercase;color:", ";font-size:14px;font-weight:700;line-height:1;transform:translate(15px,23px) scale(1);pointer-events:none;user-select:none;margin:0;transition:all 150ms ease-in-out;"], Object(theme_["cvGray"])('dark'));
var ErrorMessageContainer = external_styled_components_default.a.div.withConfig({
  displayName: "ErrorMessageContainer",
  componentId: "oo6j68-8"
})(["font-family:", ";color:", ";font-weight:400;font-size:14px;margin-top:5px;"], theme_["cvFontFamily"], Object(theme_["cvRed"])('primary'));
// CONCATENATED MODULE: ./src/Input/operations.ts
/* eslint-disable no-console */
var getInputType = function getInputType(type, showPassword) {
  var isPasswordInput = type === 'password';
  if (!isPasswordInput) return type;
  return showPassword ? 'text' : 'password';
};
var validateInputProps = function validateInputProps(_ref) {
  var id = _ref.id,
      onChange = _ref.onChange,
      changeCallback = _ref.changeCallback,
      error = _ref.error,
      sanitize = _ref.sanitize;
  var warnPrefix = "Warning for form input " + id + ":";

  if (onChange && sanitize) {
    console.warn(warnPrefix + " Looks like you are passing a sanitize function, but also overriding the default onChange function.\n    Your sanitize function will not run.");
  }

  if (error && !onChange) {
    console.warn(warnPrefix + " Looks like you are passing an error, but not using a controlled Input. Error handing is not supported on the default Input.");
  }

  if (onChange && changeCallback) {
    console.warn(warnPrefix + " Input onChangeCallback does not fire if onChange prop is also included. Remove one for expected functionality.");
  }
};
// EXTERNAL MODULE: ./src/operations/index.ts + 1 modules
var operations = __webpack_require__("./src/operations/index.ts");

// CONCATENATED MODULE: ./src/Input/Input.tsx
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }






var Input_Input = function Input(_ref) {
  var _ref$type = _ref.type,
      type = _ref$type === void 0 ? 'text' : _ref$type,
      id = _ref.id,
      _ref$labelText = _ref.labelText,
      labelText = _ref$labelText === void 0 ? '' : _ref$labelText,
      _ref$name = _ref.name,
      name = _ref$name === void 0 ? '' : _ref$name,
      _ref$isDisabled = _ref.isDisabled,
      isDisabled = _ref$isDisabled === void 0 ? false : _ref$isDisabled,
      onChange = _ref.onChange,
      _ref$value = _ref.value,
      value = _ref$value === void 0 ? '' : _ref$value,
      _ref$error = _ref.error,
      error = _ref$error === void 0 ? '' : _ref$error,
      _ref$touched = _ref.touched,
      touched = _ref$touched === void 0 ? false : _ref$touched,
      onBlur = _ref.onBlur,
      onFocus = _ref.onFocus,
      _ref$testHook = _ref.testHook,
      testHook = _ref$testHook === void 0 ? 'Input' : _ref$testHook,
      _ref$className = _ref.className,
      className = _ref$className === void 0 ? '' : _ref$className,
      _ref$errorClassName = _ref.errorClassName,
      errorClassName = _ref$errorClassName === void 0 ? '' : _ref$errorClassName,
      textMask = _ref.textMask,
      _ref$isRequired = _ref.isRequired,
      isRequired = _ref$isRequired === void 0 ? false : _ref$isRequired,
      sanitize = _ref.sanitize,
      _ref$minLength = _ref.minLength,
      minLength = _ref$minLength === void 0 ? 0 : _ref$minLength,
      _ref$maxLength = _ref.maxLength,
      maxLength = _ref$maxLength === void 0 ? 0 : _ref$maxLength,
      _ref$multiline = _ref.multiline,
      multiline = _ref$multiline === void 0 ? false : _ref$multiline,
      _ref$autoComplete = _ref.autoComplete,
      autoComplete = _ref$autoComplete === void 0 ? 'on' : _ref$autoComplete,
      changeCallback = _ref.changeCallback,
      _ref$hideCheckmark = _ref.hideCheckmark,
      hideCheckmark = _ref$hideCheckmark === void 0 ? false : _ref$hideCheckmark,
      pattern = _ref.pattern,
      inputMode = _ref.inputMode;

  var checkForValidValue = function checkForValidValue(input) {
    return input != null && input !== '';
  };

  var hasValueProp = checkForValidValue(value);

  var _useState = Object(external_react_["useState"])(false),
      showPassword = _useState[0],
      setShowPassword = _useState[1];

  var _useState2 = Object(external_react_["useState"])(value),
      inputValue = _useState2[0],
      setInputValue = _useState2[1];

  var _useState3 = Object(external_react_["useState"])(hasValueProp),
      hasValue = _useState3[0],
      setHasValue = _useState3[1];

  var _useState4 = Object(external_react_["useState"])(false),
      isFocused = _useState4[0],
      setIsFocused = _useState4[1];

  var isPasswordInput = type === 'password';
  var inputType = getInputType(type, showPassword);
  var isValid = !error && touched && hasValueProp;
  var shouldShowError = error && touched;
  var shouldShowCheckmark = !hideCheckmark && isValid;

  var noop = function noop(f) {
    return f;
  };

  Object(external_react_["useEffect"])(function () {
    return validateInputProps({
      id: id,
      onChange: onChange,
      changeCallback: changeCallback,
      error: error,
      sanitize: sanitize
    });
  }, []);
  Object(external_react_["useEffect"])(function () {
    return setHasValue(checkForValidValue(value));
  }, [value]);
  Object(external_react_["useEffect"])(function () {
    return setInputValue(value || '');
  }, [value]);

  var togglePasswordHiddenState = function togglePasswordHiddenState() {
    return setShowPassword(!showPassword);
  };

  var classNames = Object(operations["classnames"])({
    'show-error-icon': shouldShowError,
    'is-populated': hasValue || hasValueProp,
    'is-disabled': isDisabled,
    'is-focused': isFocused
  }, [className]);

  var onInputChange = function onInputChange(e) {
    var sanitizeFn = sanitize || noop;
    var newValue = sanitizeFn(e.target.value);
    setInputValue(newValue);
    setHasValue(checkForValidValue(newValue));
    if (changeCallback) changeCallback(newValue);
  };

  var onInputBlur = function onInputBlur(e) {
    setIsFocused(false);
    if (onBlur) onBlur(e);
  };

  var onInputFocus = function onInputFocus(e) {
    setIsFocused(true);
    if (onFocus) onFocus(e);
  };

  var handleAutofill = function handleAutofill(e) {
    if (e.animationName === 'onAutoFillStart') {
      setHasValue(true);
    }
  };

  var inputProps = _extends({
    value: onChange ? value : inputValue,
    disabled: isDisabled,
    id: id,
    type: inputType,
    onBlur: onInputBlur,
    onChange: onChange || onInputChange,
    onFocus: onInputFocus,
    name: name,
    required: isRequired
  }, minLength && {
    minLength: minLength
  }, {}, maxLength && {
    maxLength: maxLength
  }, {
    autoComplete: autoComplete,
    onAnimationStart: handleAutofill,
    'aria-labelledby': labelText || id,
    pattern: pattern,
    inputMode: inputMode
  });

  var renderNonTextMaskInput = function renderNonTextMaskInput(isMultiline, passedProps) {
    return isMultiline ? /*#__PURE__*/external_react_default.a.createElement(TextArea, passedProps) : /*#__PURE__*/external_react_default.a.createElement(FormInput, passedProps);
  };

  return /*#__PURE__*/external_react_default.a.createElement(external_react_default.a.Fragment, null, /*#__PURE__*/external_react_default.a.createElement(FormControl, {
    className: classNames,
    "data-cv-test": testHook,
    multiline: multiline
  }, /*#__PURE__*/external_react_default.a.createElement(Label, {
    htmlFor: id
  }, labelText), textMask && /*#__PURE__*/external_react_default.a.createElement(TextMaskedInput, _extends({}, inputProps, {
    mask: textMask
  })), !textMask && renderNonTextMaskInput(multiline, inputProps), shouldShowCheckmark && /*#__PURE__*/external_react_default.a.createElement(CheckmarkIcon, {
    className: "input-validated-icon",
    height: 15,
    width: 15
  }), shouldShowError && /*#__PURE__*/external_react_default.a.createElement(ErrorIcon, {
    className: "input-error-icon",
    height: 15,
    width: 15
  }), isPasswordInput && /*#__PURE__*/external_react_default.a.createElement(PasswordToggler, {
    onClick: togglePasswordHiddenState
  }, showPassword ? 'Hide' : 'Show')), shouldShowError && /*#__PURE__*/external_react_default.a.createElement(ErrorMessageContainer, {
    className: errorClassName
  }, error));
};

/* harmony default export */ var src_Input_Input = (Input_Input);
// CONCATENATED MODULE: ./src/Input/index.ts
/* concated harmony reexport default */__webpack_require__.d(__webpack_exports__, "default", function() { return src_Input_Input; });


/***/ }),

/***/ "./src/operations/index.ts":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);

// CONCATENATED MODULE: ./src/operations/classnames.ts
/* harmony default export */ var classnames = (function (nameMap, nameList) {
  return Object.keys(nameMap).filter(function (name) {
    return nameMap[name];
  }).concat(nameList).filter(Boolean).join(' ');
});
// CONCATENATED MODULE: ./src/operations/index.ts
/* concated harmony reexport classnames */__webpack_require__.d(__webpack_exports__, "classnames", function() { return classnames; });



/***/ }),

/***/ "@carvana/icons/AlertCircle":
/***/ (function(module, exports) {

module.exports = require("@carvana/icons/AlertCircle");

/***/ }),

/***/ "@carvana/icons/CheckCircle":
/***/ (function(module, exports) {

module.exports = require("@carvana/icons/CheckCircle");

/***/ }),

/***/ "@carvana/theme":
/***/ (function(module, exports) {

module.exports = require("@carvana/theme");

/***/ }),

/***/ "react":
/***/ (function(module, exports) {

module.exports = require("react");

/***/ }),

/***/ "react-text-mask":
/***/ (function(module, exports) {

module.exports = require("react-text-mask");

/***/ }),

/***/ "styled-components":
/***/ (function(module, exports) {

module.exports = require("styled-components");

/***/ })

/******/ });
//# sourceMappingURL=Input.js.map